import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";
import {applyPruneToTimelineItem} from "../base/training-literals";

class GroupSelect extends Action {
    until;
    model;
    defaultAction;
    timelineMap;
    _stopper;

    constructor(props) {
        super(props);
        this.until = props.until;
        this.model = props.model;
        this.defaultAction = props.defaultAction && new LoadTimeline(props.defaultAction);
        this.pickAction = Object.fromEntries(props.timelineMap.map(item => {
            const timelineItem = applyPruneToTimelineItem(item, props.prune);
            return [item.group.id, new LoadTimeline(timelineItem)];
        }));
        this._stopper = () => {};
    }

    async execute(eventLoop) {
        let self = this;
        this._stopper = activateGroupSelect();
        setTimeout(this._stopper, self.until - self.startTime);

        function activateGroupSelect() {
            VR.canvas.addEventListener('group_selected', handleGroupSelect);
            return () => VR.canvas.removeEventListener('group_selected', handleGroupSelect);
        }

        async function handleGroupSelect(event) {
            const groupData = event.detail.groupData;
            const modelId = groupData?.modelId;
            let branchNode = MeshHierarchyViewFeatureData.getDataFromBranchID(groupData?.branchID);
            let done = false;
            while (true) {
                const group = GroupData.getGroupDataFromBranchId(branchNode?.branchID);
                if (group) {
                    const nextAction = getNextTimeline(modelId, group.id);
                    if (nextAction) {
                        done = true;
                        self._stopper();
                        await nextAction.execute(eventLoop);
                        break;
                    }
                }

                branchNode = branchNode?.parent;
                if (branchNode?.branchID === "-1") {
                    break;
                }
            }

            if (!done && self.defaultAction && (self.defaultAction.timelines.length || (self.defaultAction.events && self.defaultAction.events.length))) {
                self._stopper();
                await self.defaultAction.execute(eventLoop);
            }
        }

        function getNextTimeline(modelId, groupId) {
            if (!self.model || eventLoop.training.resources[self.model.id]?.resourceId === modelId) {
                if (self.pickAction[groupId]) {
                    return self.pickAction[groupId];
                }

                if (self.defaultAction && (self.defaultAction.timelines.length || (self.defaultAction.events && self.defaultAction.events.length))) {
                    return self.defaultAction;
                }

            }
        }
    }

    async stop() {
        this._stopper();
    }
}

export default GroupSelect;
